import { useState } from 'react';
import { CardsSection } from 'components/layout/Section/CardsSection';
import { CenteredDashboardContent } from 'features/dashboard/DashboardContent';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';
import { ContractDetailCard } from './cards/ContractDetailCard';
import { SubscriberSummaryCard } from './cards/SubscriberSummaryCard';
import { SpecialConditionsCard } from './cards/SpecialConditionsCard';
import { MandatsCard } from './cards/MandatsCard';
import { SignContractCard } from './cards/SignContractCard';
import { LockBadge } from '../components/LockBadge';
import { GroupContractHeader } from '../components/GroupContractHeader';
import { GroupContractDocumentsSection } from '../components/GroupContractDocumentsSection';
import { useGroupContractProcess } from '../contexts/GroupContractProcessContext';

export const ContractualizationStep = () => {
  const { t } = useDynamicTranslation([NsKey.Contract, NsKey.Common]);
  const { isLocked } = useGroupContractProcess();
  // CP + souscripteur (avec pièce d'identité valide) doivent être OK pour déclencher
  // la signature des mandats. Pour signer le contrat il faut en plus que tous les
  // mandats SEPA uniques soient signés (ou que le contrat soit en paiement par aliments
  // — auquel cas la card mandats se masque et `allMandatsSigned` est piloté différemment).
  const [conditionsFilled, setConditionsFilled] = useState(false);
  const [subscriberValid, setSubscriberValid] = useState(false);
  const [allMandatsSigned, setAllMandatsSigned] = useState(false);

  const prerequisitesReady = conditionsFilled && subscriberValid;
  const canSignContract = prerequisitesReady && allMandatsSigned;

  return (
    <CenteredDashboardContent>
      <div className="flex flex-col max-w-5xl mx-auto">
        <div className="flex flex-col gap-4 p-8 bg-white border border-gray-200 rounded-xl shadow-sm">
          <GroupContractHeader />

          {/* Section 1 — Informations du contrat. Cadenas à droite quand verrouillé. */}
          <CardsSection
            title={t('GROUP_CONTRACT_PROCESS.CONTRACTUALIZATION_STEP.INFOS_SECTION')}
            titleAside={isLocked ? <LockBadge /> : undefined}
          >
            <div className="grid grid-cols-2 gap-4">
              <ContractDetailCard />
              <SubscriberSummaryCard onValidityChange={setSubscriberValid} />
              <div className="col-span-2">
                <SpecialConditionsCard onValidityChange={setConditionsFilled} />
              </div>
            </div>
          </CardsSection>

          {/* Section 2 — Signature : regroupe mandats SEPA (masqués si paiement par aliments)
              et signature du contrat dans le même bloc. */}
          <CardsSection title={t('GROUP_CONTRACT_PROCESS.CONTRACTUALIZATION_STEP.SIGNATURE_SECTION')}>
            <div className="flex flex-col gap-4">
              <MandatsCard
                disabled={!isLocked && !prerequisitesReady}
                onAllSignedChange={setAllMandatsSigned}
              />
              <SignContractCard disabled={!isLocked && !canSignContract} />
            </div>
          </CardsSection>

          {/* Section 3 — Documents générés (contrat collectif, version signée à venir). */}
          <GroupContractDocumentsSection />
        </div>
      </div>
    </CenteredDashboardContent>
  );
};
